import React from 'react';

const AccountOrder = ({ name, url, createdAt, total }) => (
  <tr className="c-account-orders__row c-account-orders__row--orders body-2">
    <td className="c-account-orders__cell c-account-orders__cell-url" data-label="ORDER">
      <a href={url}>
        <span>{name}</span>
      </a>
    </td>
    <td className="c-account-orders__cell" data-label="DATE">
      {createdAt}
    </td>
    <td className="c-account-orders__cell" data-label="TOTAL">
      {total}
    </td>
  </tr>
);

export default AccountOrder;
